/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeOrgCount } from './serviceTypeOrgCount';


export interface VcdsOrgsInfoSummary { 
    /**
     * Number of CSP orgs onboarded
     */
    num_vcds_tenant_orgs?: number;
    orgs_by_service_type?: Array<ServiceTypeOrgCount>;
}

